import request from '@/utils/ai-train-request'

// AI训战 - 知识库素材（ai_knowledge：file_url/parsed_text/char_count/state）
const apiPath = '/admin/knowledge'

const aiTrainKnowledgeApi = {
  fetchList(query) {
    return request({ url: apiPath, method: 'get', params: query })
  },
  /**
   * 上传素材文件（文件本身走 COS 直传，这里只落记录并触发后端解析），
   * data: {title, fileUrl}
   */
  create(data) {
    return request({ url: apiPath, method: 'post', data })
  },
  /**
   * 重新解析（parsed_text/char_count 由后端异步生成）
   */
  reparse(id) {
    return request({ url: `${apiPath}/${id}/parse`, method: 'post' })
  },
  deleteById(id) {
    return request({ url: `${apiPath}/${id}`, method: 'delete' })
  },
  setState(id, state) {
    return request({ url: `${apiPath}/${id}/state`, method: 'put', data: { state } })
  }
}

export default aiTrainKnowledgeApi
